import { FC, ReactNode } from 'react';

import { Box, rem } from '@bonusly/design-system';

const getStyle = (isActive: boolean) => {
	if (isActive) {
		return {
			bg: 'primary.bgAlpha',
			color: 'primary.fgStrong',
			cursor: 'pointer',
			_focusVisible: { outline: '2px solid', outlineColor: 'blue.500', borderRadius: 'md', outlineOffset: '-2px' },
		};
	}

	return {
		bg: 'none',
		color: 'secondary.fg',
		_hover: { bg: 'secondary.bgAlpha' },
		cursor: 'pointer',
		_focusVisible: { outline: '2px solid', outlineColor: 'blue.500', borderRadius: 'md', outlineOffset: '-2px' },
	};
};

type UserNavActionProps = {
	children: ReactNode;
	isActive?: boolean;
	isExpanded: boolean;
	onClick: () => void;
};

export const UserNavAction: FC<UserNavActionProps> = ({ children, isActive = false, isExpanded, onClick, ...props }) => {
	return (
		<Box
			as="button"
			type="button"
			onClick={onClick}
			w="100%"
			py={rem(8)}
			px={isExpanded ? rem(10) : rem(8)}
			borderRadius="md"
			textAlign="left"
			{...getStyle(isActive)}
			{...props}
		>
			{children}
		</Box>
	);
};
